import { Group } from "@mui/icons-material";
import styled from "styled-components";

export const DetailLinkIcon = styled(Group)`
    && {
        width: 15px;
        height: 15px;
        margin-right: 5px;
    }
`;
